import { formatExternalAddressText } from 'pages/OfferPortal/helper';
import { Icons, ICON_VARIANT_TYPE } from '../../Icons';

import styles from './styles.module.scss';

export const LocationDetails = (props) => {
  const { PropertyTransaction } = props;
  const Property = PropertyTransaction?.Property;

  const formatLocationAddress = () => {
    if (!Property?.Address?.PlaceName) {
      return 'N/A';
    }

    return formatExternalAddressText(Property?.Address);
  };

  return (
    <div>
      <div className={styles.detailsArea}>
        <p className={styles.title}>Location</p>
        <p className={styles.subTitle}>{formatLocationAddress()}</p>
        <a
          className={styles.link}
          href={`http://maps.google.com/?q=${Property?.Address?.PlaceName}`}
          target="_blank"
          rel="noreferrer"
        >
          Show on Map
        </a>
      </div>
    </div>
  );
};
